var getBestFitQuality = function getBestFitQuality(_ref) {
  var sources = _ref.sources,
      playerWidth = _ref.playerWidth,
      type = _ref.type;
  if (!playerWidth || !sources.length) return;
  var BEST_FIT_INDEX = 0;
  var ratio = sources[0].width / sources[0].height;
  var height = Math.round(playerWidth / ratio);
  var correctQuality = height * devicePixelRatio;
  var filteredSources = sources.filter(function (s) {
    return s.type === type;
  });
  var sortedExistingQualities = filteredSources.map(function (v) {
    return v.height;
  }).sort(function (a, b) {
    return a - b;
  });
  var bestAvailableQuality = sortedExistingQualities[sortedExistingQualities.length - 1];
  var calculatedQuality = sortedExistingQualities.filter(function (v) {
    return v >= correctQuality;
  })[BEST_FIT_INDEX] || bestAvailableQuality;
  return calculatedQuality;
};

export default getBestFitQuality;